import React from 'react';
import { Link } from 'react-router-dom';
import './Slide.scss';

/**
 * Determines if a URL points to a video file.
 */
function isVideo(url) {
  if (!url) return false;
  const ext = url.split('?')[0].split('.').pop().toLowerCase();
  return ['mp4', 'webm', 'ogg', 'mov'].includes(ext);
}

/**
 * Slide component for the homepage reel.
 *
 * Props (from API showcase response):
 *   slide.title        - Display title
 *   slide.subtitle     - Optional subtitle
 *   slide.image_url    - Primary/thumbnail image (fallback background)
 *   slide.images       - Array of media URLs (images & videos)
 *   slide.cta_text     - Call-to-action button text
 *   slide.type         - event | service | sauna | package
 *   slide.id           - Unique identifier (used for routing)
 *   slide.slug         - URL slug (if available, for direct routing)
 */
const Slide = ({ slide, index }) => {
  // Determine the primary background media
  // Use the first item from images array, or fallback to image_url
  const primaryMedia = (slide.images && slide.images.length > 0)
    ? slide.images[0]
    : slide.image_url;

  const isPrimaryVideo = isVideo(primaryMedia);

  // Route target: clicking goes to the offerings listing or filtered view
  const routeTo = slide.slug
    ? `/offerings/${slide.slug}`
    : '/offerings';

  return (
    <div className="card-wrapper">
      <div className="card card-fullscreen">
        {/* Background Media (Image or Video) */}
        <div className="card-img">
          {isPrimaryVideo ? (
            <video
              src={primaryMedia}
              autoPlay
              muted
              loop
              playsInline
              className="slide-video"
            />
          ) : (
            <img src={primaryMedia} alt={slide.title} />
          )}
        </div>

        {/* Overlay */}
        <div className="background-color"></div>

        {/* Slide Content Overlay */}
        <div className="card-img-overlay">
          {slide.subtitle && (
            <span className="card-subtitle">{slide.subtitle}</span>
          )}
          <h2 className="card-title">{slide.title}</h2>
          <Link to={routeTo} className="card-link">
            {slide.cta_text || 'View Details'}
          </Link>
        </div>

        {/* Slide Counter */}
        <div className="slide-counter">
          <span>{String(index + 1).padStart(2, '0')}</span>
        </div>
      </div>
    </div>
  );
};

export default Slide;
